import { TweenMax, Power3 } from 'gsap';
import {
  Graphics,
  Sprite,
  filters,
  Point,
  RenderTexture,
  SCALE_MODES,
} from 'pixi.js';
import engine from '@/scripts/engine';
import cursor from '@/scripts/cursor';

class MouseTrail {
  constructor(app) {
    this.app = app;
    this.container = new Sprite();
    this.texture = RenderTexture.create({
      width: this.app.renderer.width,
      height: this.app.renderer.height,
      scaleMode: SCALE_MODES.LINEAR,
      resolution: 1,
    });

    const g = new Graphics();
    g.beginFill(0x000000)
      .drawRect(0, 0, this.app.renderer.width, this.app.renderer.height)
      .endFill();
    this.container.addChild(g);

    this.blur = new filters.BlurFilter(10, 1);
    this.container.filters = [this.blur];
  }

  render() {
    const g = new Graphics();
    g.beginFill(0xffffff)
      .drawCircle(0, 0, 120)
      .endFill();
    g.anchor = new Point(0.5, 0.5);
    g.position.x = cursor.ref.coords.x + 50;
    g.position.y = cursor.ref.coords.y + 50;
    this.container.addChild(g);
    TweenMax.to(g, 0.6, {
      alpha: 0,
      ease: Power3.easeOut,
      onComplete: () => {
        this.container.removeChild(g);
        g.destroy({ texture: true, children: true, baseTexture: true });
      },
    });

    this.app.renderer.render(this.container, this.texture);
  }

  play() {
    engine.add(() => { this.render(); }, 'render-mouse-trail');
  }

  pause() { // eslint-disable-line
    engine.remove('render-mouse-trail');
  }
}

export default MouseTrail;
